<template>
  <div id="current-remind">
    <div class="ipub-h2 flex mar-b-20 relative line-h-40">
      <span>Current Remind</span>
      <ipub-radio :checked="checked"
                  class="ipub-p2 mar-l-20"
                  style="align-items: center;"
                  @change="changeAlert">
        Only View the one not reach the goal
      </ipub-radio>
      <div class="ipub-p1 right-option"
           v-show="role.codeList&&role.codeList.includes('STATISTICS.GRAPHICAL_ANALYSIS.ARTICLE_TYPE.EXPORT')">
        <ipub-button type="primary"
                     @click="exp">
          Export
        </ipub-button>
      </div>
    </div>

    <div class="artical-alert ipub-p2">
      <div class="artical-alert-list content-bg mar-b-20"
           v-for="(value,key) in articalAlert"
           v-show="(checked && !(value.list && value.list.every(item=> (item.symbolType==='GT' && item.articleNumber>item.number) || (item.symbolType==='LTE' && item.articleNumber<=item.number)))) || !checked"
           :key="key+123456">
        <div class="ipubw-p1 line-h-40 content-color title">{{value.journalName}}</div>
        <div class="artical-alert-list-item flex"
             v-for="(item,index) in value.list"
             v-show="(checked && !((item.symbolType==='GT' && item.articleNumber>item.number) || (item.symbolType==='LTE' && item.articleNumber<=item.number)) || !checked)"
             :key="index+'123'">
          <ipub-icon type="icontick"
                     class="success-color"
                     v-if="(item.symbolType==='GT' && item.articleNumber>item.number) || (item.symbolType==='LTE' && item.articleNumber<=item.number)"></ipub-icon>
          <ipub-icon class="key-color"
                     type="iconClose"
                     v-else></ipub-icon>
          <div class="flex mar-l-20"
               style="flex-wrap: wrap;width: 280px;">
            <div v-for="(eType,eTypeIndex) in item.articleTypeList"
                 :key="eType.id">
              {{ manuscriptType[eType.code]}} <span v-if="!(item.articleTypeList.length===1 || eTypeIndex==item.articleTypeList.length-1)"> & &nbsp;</span></div>
          </div>
          <div style="width:130px">{{symbol[item.symbolType]}} {{item.number}} / {{item.type}}</div>
          <div class="mar-l-20">current {{item.articleNumber}}</div>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import { mapGetters } from 'vuex'
import { statisticJournalAtypeAlert } from '@/api/statistic'
import user from '@/api/user'
import help from '@/utils/help'

export default {
  data () {
    return {
      params: {},
      checked: false,
      articalAlert: [],
      symbol: {
        GT: '＞',
        LTE: '≤'
      },

    }
  },
  computed: {
    ...mapGetters({
      manuscriptType: 'getManuscriptType',
      role: 'getUser'
    })
  },
  mounted () {
    this.getData(this.params)
  },
  methods: {
    async getData () {
      const response = await statisticJournalAtypeAlert.get(this.params)
      const res = await user.setting('JOURNAL_ATYPE_ALERT')
      this.version = res ? res.version : ''
      this.articalAlert = response ? response : []

      if (res && res.value === '1') {
        this.checked = true
      } else {
        this.checked = false
      }
    },
    async exp () {
      const res = await statisticJournalAtypeAlert.export(this.params)
      help.download(res.url, res.fileName)
    },
    async changeAlert (val) {
      let value = 0
      this.checked = !val
      if (this.checked) {
        value = 1
      } else {
        value = 0
      }
      await user.editSetting('JOURNAL_ATYPE_ALERT', { value, version: this.version })
      const res = await user.setting('JOURNAL_ATYPE_ALERT')
      this.version = res ? res.version : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import './main.scss';
#current-remind {
  .title {
    // width: 480px;
    // height: 30px;
    background: #4c516d;
    padding: 0 12px;
  }
  .part {
  }
  .artical-alert {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &-list {
      width: 32.4%;
      &-item {
        display: flex;
        align-items: center;
        padding: 6px 12px;
        border-radius: 2px;
        border-bottom: 1px solid rgba(109, 114, 120, 0.22);
        box-sizing: border-box;
        &:nth-last-child(1) {
          border-bottom: transparent;
        }
      }
    }
  }
}
</style>
